// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"33490e5b","420":"36e00f0c","453":"96a61b48","594":"fa092ea0","685":"50f073be","788":"79dcd0ef"}[chunkId] + ".chunk.js";
};